import { TeacherActionType, TeacherInitialState } from "../interfaces/interfaces";
import { TeacherType } from "../interfaces/actionTypes";

const teacherInitialState: TeacherInitialState = {
  loading: false,
  error: null,
  emailSent: false,
  courseCreated: "",
  data: {
    user_id: "",
    username: "",
    fullname: "",
    role: "",
    email: "",
    token: "",
    expiresIn: "",
    message: "",
    success: false
  },
  courses: { "courses": [] },
  assignments: {
    "assignments": [{
      "course_id": "",
      "course_name": "",
      "course_description": "",
      "teacher_id": "",
      "teacher_username": "",
      "assignment_id": "",
      "assignment_grade": "",
      "assignment_due_date": "",
      "assignment_link": ""
    }]
  },
  notes: {
    "notes": []
  },
  lessons: {
    "lessons": []
  },
  submittedAssignments: [{
    "assignment_id": "",
    "assignment_grade": 0,
    "assignment_link": "",
    "assignment_score": null,
    "assignment_due_date": "",
    "teacher_id": "",
    "course_id": "",
    "course_name": "",
    "student_id": "",
    "teacher_username": "",
    "teacher_fullname": "",
    "student_fullname": "",
    "student_username": ""
  }],
  gradeStatus: ""
}

export default function teacherReducer(state: TeacherInitialState = teacherInitialState, action: TeacherActionType): TeacherInitialState {
  switch (action.type) {
    case TeacherType.LOGIN:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
        emailSent: false
      }
    case TeacherType.REGISTER:
      return {
        ...state,
        loading: false,
        error: null,
        data: action.payload,
        emailSent: false
      }
    case TeacherType.LOGOUT:
      return {
        ...state,
        data: {
          user_id: "",
          username: "",
          fullname: "",
          role: "",
          email: "",
          token: "",
          expiresIn: "",
          message: "",
          success: false
        },
        courses: { "courses": [] },
        loading: false,
        error: null,
        emailSent: false
      }
    case TeacherType.AUTH_ERROR:
      return {
        ...state,
        error: action.payload,
        data: {
          user_id: "",
          username: "",
          fullname: "",
          role: "",
          email: "",
          token: "",
          expiresIn: "",
          message: "",
          success: false
        },
        loading: false,
        emailSent: false
      }
    case TeacherType.GET_COURSES:
      return {
        ...state,
        courses: action.payload,
        error: null,
        emailSent: false,
        loading: false
      }
    case TeacherType.CREATE_COURSES:
      return {
        ...state,
        courseCreated: action.payload,
        error: null,
        emailSent: false,
        loading: false
      }
    case TeacherType.GET_ASSIGNMENTS:
      return {
        ...state,
        assignments: action.payload,
        error: null,
        emailSent: false,
        loading: false
      }
    case TeacherType.GET_SUBMITTED_ASSIGNMENTS:
      return {
        ...state,
        submittedAssignments: action.payload,
        error: null,
        emailSent: false,
        loading: false
      }
    case TeacherType.GRADE_ASSIGNMENT:
      return {
        ...state,
        gradeStatus: action.payload.message,
        error: null,
        emailSent: false,
        loading: false
      }
    case TeacherType.GET_NOTES:
      return {
        ...state,
        notes: action.payload,
        error: null,
        emailSent: false,
        loading: false
      }
    case TeacherType.GET_LESSONS:
      return {
        ...state,
        lessons: action.payload,
        error: null,
        emailSent: false,
        loading: false
      }
    case TeacherType.LOADING:
      return {
        ...state,
        loading: true
      }
    default:
      return state;
  }
}